<template>
<CNavGroup :class="navGroupClasses" :visible="activeNavItem || navElementObj.expanded" v-if="navElementObj.children" @visible-change="togglingNavGroup">
  <template #togglerContent>
    <DocPageSidebarNavItemContent
      :collapsedIcon="navElementObj.collapsedIcon"
      :expandedIcon="navElementObj.expandedIcon"
      :title="navElementObj.title"
      :expanded="activeNavItem || navElementObj.expanded"
      :activeNavItem="activeNavItem"
    />
  </template>
  <DocPageSidebarNavElement v-for="navChild in navElementObj.children" :key="navChild.title"
    :child="true"
    :navElement="navChild"
  />
</CNavGroup>
<CNavItem href="#" @click="this.$router.push({ name: navElementObj.routerKey })" v-else>
  <DocPageSidebarNavItemContent
    :collapsedIcon="navElementObj.collapsedIcon"
    :expandedIcon="navElementObj.expandedIcon"
    :title="navElementObj.title"
    :expanded="activeNavItem || navElementObj.expanded"
    :activeNavItem="activeNavItem"
  />
</CNavItem>
</template>

<script>
import DocPageSidebarNavItemContent from './DocPageSidebarNavItemContent.vue'

export default {
  props: {
    child: {
      type: Boolean,
      default: false,
      required: false
    },
    navElement: {
      required: true
    }
  },
  computed: {
    navGroupClasses () {
      return (this.child ? 'custom-sidebar-nav-child' : `custom-sidebar-nav${this.activeNavItem ? ' custom-active-sidebar-element' : ''}`)
    },
    navElementObj () {
      return this.navElement
    },
    activeNavItem () {
      return ((this.$store.state.navKeys || []).indexOf(this.navElementObj.navKey) > -1)
    }
  },
  methods: {
    togglingNavGroup (navOpen) {
      this.navElementObj.expanded = navOpen
    }
  },
  components: { DocPageSidebarNavItemContent }
}
</script>

<style>
.custom-sidebar-nav {
  font-size: 84% !important;
}
.custom-sidebar-nav-child {
  font-size: 100% !important;
}
.custom-sidebar-nav .nav-group-items .nav-link {
  padding-left: 32px !important;
}
.custom-sidebar-nav .nav-link {
  padding-top: 9px !important;
  padding-bottom: 9px !important;
}
.custom-sidebar-nav .custom-sidebar-nav-child .nav-group-items .nav-link {
  padding-left: 64px !important;
}
.nav-link {
  white-space: normal !important;
  color: #979aaa !important;
}
</style>